export default function Header() {
  return (
    <header className="relative z-10 bg-white/70 backdrop-blur-md border-b border-cream-dark/40">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 py-5 sm:py-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-primary tracking-tight text-center font-heading">
          HELP CENTER
        </h1>
      </div>
    </header>
  );
}